export default __webpack_public_path__ + "ui/assets/img/arrow-sort-desc-20.svg";